import React, { useEffect } from 'react';
import PageHeader from '../../components/headers/PageHeader';
import ContactForm from '../../components/contactform/ContactForm';
import skylink from '../../assets/Images/skylink.png';
import './AboutUs.css';

const timelineItems = [
    {
        date: 'October 2011',
        title: 'Foundation of Eupraxia',
        subtitle: 'Vadodara, Gujarat, India',
        text: 'Eupraxia Centre for Clinical Excellence was incorporated as a clinical research organization on October 17, 2011, to offer clinical research services. The organization also completed its first client audit at its new office.'
    },
    {
        date: 'April 2012',
        title: 'First Clinical Trial Project',
        text: 'Successfully completed the first clinical trial management project for a pharmaceutical client, marking Eupraxia’s entry into clinical trial support and clinical data services.'
    },
    {
        date: 'March 2014',
        title: 'Introduction of Data Management Services',
        text: 'Expanded service offerings by adding clinical data management capabilities, helping clients handle larger volumes of clinical trial data with improved structure and quality.'
    },
    {
        date: 'July 2015',
        title: 'Addition of Biostatistics Services',
        text: 'Introduced biostatistics services to provide advanced statistical analysis and reporting support for clinical trials.'
    },
    {
        date: 'June 2017',
        title: 'ISO Certification and Office Expansion',
        text: 'Achieved ISO certification, strengthening the quality management system for clinical research services. Eupraxia also grew to a team size of 18 and acquired its second office.'
    },
    {
        date: 'November 2019',
        title: 'Launch of Nonclinical Biostatistics and SEND Services',
        text: 'Launched nonclinical biostatistical analytics and SEND submission services for single-dose, repeat-dose, and safety pharmacology studies.'
    },
    {
        date: 'January 2020',
        title: 'First Carcinogenicity Study Win',
        text: 'Won the first carcinogenicity study involving more than 1,000 animals from one of India’s top three ranking sponsors.'
    },
    {
        date: 'March 2020',
        title: 'Expansion into Global Markets',
        text: 'Successfully expanded operations into international markets, offering clinical research services to global clients across the Middle East and the USA.'
    },
    {
        date: 'March 2020',
        title: 'Launch of Alceon® Medical Device CRO Division',
        text: 'Started the medical device-focused CRO division, branded as Alceon®, offering RAQA services to European and Indian clients.'
    },
    {
        date: 'February 2021',
        title: 'Launch of First Clinical Trial Study for Pharma Product',
        text: 'Launched the first clinical trial study for a pharmaceutical product, strengthening Eupraxia’s clinical operations and trial execution capabilities.'
    },
    {
        date: 'March 2021',
        title: '10-Year Anniversary',
        text: 'Celebrated 10 years of providing high-quality clinical research services, reflecting on a decade of growth, delivery, and client support.'
    },
    {
        date: 'April 2021',
        title: 'Bangalore Office Expansion',
        text: 'Opened the third office in Bangalore, India, and grew to a team size of more than 80 professionals.'
    },
    {
        date: 'May 2021',
        title: 'ISO 13485 Certification for Alceon®',
        text: 'Earned ISO 13485 certification for Alceon®, the medical device RA/QA division of Eupraxia, from the British Standards Institution in the UK.'
    },
    {
        date: 'June 2021',
        title: 'Launch of CMC Biostatistics Services',
        text: 'Launched CMC biostatistics services to support analytical validation, stability analysis, process validation, and regulatory-ready CMC analytics.'
    },
    {
        date: 'August 2021',
        title: 'First Medical Device Clinical Trial Study',
        text: 'Launched the first clinical trial study for a medical device, expanding Eupraxia’s capabilities across medical device clinical research.'
    },
    {
        date: 'October 2021',
        title: 'Launch of Data Science Division',
        text: 'Introduced a specialized data science division to offer advanced data analysis, automation, and scientific data solutions to clients.'
    },
    {
        date: 'March 2022',
        title: 'First Global Pharma Client',
        text: 'Secured the first global pharmaceutical client, marking a major milestone in Eupraxia’s international growth strategy.'
    },
    {
        date: 'October 2022',
        title: 'Strategic Partnership with German Consulting Group',
        text: 'Signed a long-term strategic partnership with a Germany-based pharma drug discovery consulting group.'
    },
    {
        date: 'March 2023',
        title: 'Annual General Meeting 2023',
        text: 'Successfully held the Annual General Meeting on March 31, 2023, with key insights into business growth and future strategy.'
    },
    {
        date: 'April 2023',
        title: 'Fourth Office Expansion in India',
        text: 'Opened the fourth office in India and grew to a team size of more than 120 professionals.'
    },
    {
        date: 'May 2023',
        title: 'Radiopharmaceutical Clinical Trial Analytics',
        text: 'Entered radiopharmaceutical clinical trial studies with ISS and ISE analyses of 12 studies across phases in renal cell carcinoma.'
    },
    {
        date: 'July 2023',
        title: 'Partnership with Leading Biotech Firm',
        text: 'Announced a new partnership with a leading biotech company to offer enhanced clinical trial services.'
    },
    {
        date: 'October 2023',
        title: 'Oncology Clinical Trial Submission Support',
        text: 'Supported a bundle of more than 14 individual oncology clinical trial studies across Phase 1, Phase 2a/2b, and Phase 3 for SAP development, CDISC conversions, TLFs, and CSR.'
    },
    {
        date: 'May 2024',
        title: 'First German AMNOG Submission',
        text: 'Completed the first German AMNOG submission for two clinical trial studies using quantitative meta-analysis.'
    },
    {
        date: 'October 2024',
        title: 'Start of Eupraxia-US Operations',
        text: 'Started Eupraxia-US operations with an office in Washington, DC.'
    },
    {
        date: 'October 2024',
        title: 'First Full IND SEND Package Development',
        text: 'Completed the first full-fledged IND submission SEND package development for 18 studies for one of India’s top two rated pharmaceutical sponsors.'
    },
    {
        date: 'September 2025',
        title: 'Second Eupraxia-US Office in New Jersey',
        text: 'Opened the second Eupraxia-US office in New Jersey to support continued growth in the US market.'
    },
    {
        date: 'January 2026',
        title: 'Launch of Clinical Operations for CT in USA',
        text: 'Launched clinical operations for clinical trials in the USA, expanding Eupraxia’s operational capabilities in the US region.'
    },
    {
        date: 'May 2026',
        title: 'Launch of Commercialization and RWE Studies',
        text: 'Launched commercialization and real-world evidence studies in the USA and UAE, expanding support across evidence generation, market access, and post-approval research.'
    }
];

const numbers = [
    { value: '13', label: 'Years in Business' },
    { value: '75+', label: 'Personnel' },
    { value: '1M+', label: 'Research Data Points Analyzed' },
    { value: '100+', label: 'Clients Served' },
    { value: '25+', label: 'Research Partners' },
    { value: '10+', label: "Countries We've Worked In" },
    { value: '500+', label: 'Clinical Studies Supported' },
    { value: '50+', label: 'Data Science Projects Completed' },
    { value: '5+', label: 'Years of ISO:13485 Certified' }
];

function AboutUs() {
    useEffect(() => {
        const items = document.querySelectorAll('.about-timelineItem');

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('about-timelineItem--visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );

        items.forEach((item) => observer.observe(item));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="about-page">
            <PageHeader
                mediaSrc={skylink}
                mediaType="image"
                title="About Us"
            />

            <section className="about-section">
                <h2>Our Mission</h2>
                <p>
                    At Eupraxia, we are dedicated to advancing clinical research
                    through innovative and ethical practices.
                </p>
                <p>
                    Our mission is to accelerate the development, approval, and
                    adoption of healthcare innovations through solutions that improve
                    outcomes for sponsors, healthcare providers, and patients worldwide.
                </p>
            </section>

            <section className="about-section">
                <h2>Our Impact</h2>
                <p>
                    At Eupraxia, we are committed to making a lasting impact on
                    healthcare through excellence in clinical research. Our ongoing
                    efforts continue to shape the future of medicine and improve
                    patient outcomes worldwide.
                </p>
            </section>

            <section className="about-section">
                <h2>Eupraxia Timeline</h2>

                <div className="about-timeline">
                    {timelineItems.map((item, index) => (
                        <div
                            className={`about-timelineItem ${
                                index % 2 === 0
                                    ? 'about-timelineItem--left'
                                    : 'about-timelineItem--right'
                            }`}
                            key={`${item.date}-${index}`}
                        >
                            <div className="about-timelineDate">
                                {item.date}
                            </div>

                            <div className="about-timelineDot" />

                            <article className="about-timelineCard">
                                <h3>{item.title}</h3>

                                {item.subtitle && (
                                    <h4>{item.subtitle}</h4>
                                )}

                                <p>{item.text}</p>
                            </article>
                        </div>
                    ))}
                </div>
            </section>

            <section className="about-numbersSection">
                <div className="about-numbersHeading">
                    <h2>Eupraxia by the Numbers</h2>
                </div>

                <div className="about-numbersGrid">
                    {numbers.map((item, index) => (
                        <div className="about-numberCard" key={`${item.value}-${index}`}>
                            <h4>{item.value}</h4>
                            <p>{item.label}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="about-contactSection">
                <h2>Let's Discuss Your Requirements</h2>
                <ContactForm />
            </section>
        </div>
    );
}

export default AboutUs;